import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons"
import CustomModal from "../basics/interface/CustomModal"
import Loader from "../basics/Loader"
import { COLORS } from "../../utilities/Constants"

// Version V2 (CustomModal) de AtelierCheckRedirect — vérifie que la location
// liée est restituée avant de poursuivre. Props identiques au legacy.
const AtelierCheckRedirectV2 = ({ state, error, redirect, closeModal }) => {
	const centered = {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: 12,
		textAlign: "center",
		padding: "8px 0",
	}
	if (error) {
		return (
			<CustomModal
				title={"Erreur de vérification"}
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{ title: "Ok", styleName: "primary", onClick: closeModal },
				]}
			>
				<div style={centered}>
					<FontAwesomeIcon
						icon={faTimesCircle}
						size="2x"
						style={{ color: COLORS.danger }}
					/>
					<div>{`${error.status}`}</div>
					<div>{`${error.msg}`}</div>
					<div>Ce rapport d'erreur a été sauvegardé</div>
				</div>
			</CustomModal>
		)
	}
	if (state === 0) {
		return (
			<CustomModal
				title={"Vérification…"}
				showFooter={false}
				showCloseButton={false}
				onClose={closeModal}
			>
				<Loader size={28} padding={24} />
			</CustomModal>
		)
	}
	if (state === 1) {
		return (
			<CustomModal
				title={"Location non restituée"}
				subtitle={
					"Le véhicule prêté doit d'abord être restitué. Ouvrir la fiche de prêt ?"
				}
				onClose={closeModal}
				showCloseButton={false}
				buttons={[
					{ title: "Non", styleName: "secondary", onClick: closeModal },
					{ title: "Oui", styleName: "primary", onClick: redirect },
				]}
			/>
		)
	}
	return null
}

export default AtelierCheckRedirectV2
